import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const HomePage = ({ calculators }) => {
  const navigate = useNavigate();

  const handleCalculatorClick = (id) => {
    navigate(`/${id}`);
  };

  const faqs = [
    {
      q: "Werden meine Einträge gespeichert?",
      a: "Nein. Alle Berechnungen erfolgen in Echtzeit. Es wird nichts gespeichert."
    },
    {
      q: "Muss ich irgendetwas installieren?",
      a: "Nein. Alles funktioniert im Browser."
    },
    {
      q: "Funktioniert es auf allen Geräten?",
      a: "Ja. Telefon, Tablet und Computer."
    },
    {
      q: "Ist es kostenlos?",
      a: "Ja."
    }
  ];

  return (
    <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 py-8">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-12"
      >
        <h1 style={{
          textAlign: 'justify',
          fontWeight: '700'
        }} className="text-6xl md:text-7xl lg:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-300 to-pink-300 mb-4">
          OpaLife-Rechenwerk
        </h1>
        <p className="text-lg md:text-xl text-purple-200/80 font-light">
          Alles umrechnen, alles berechnen
        </p>
      </motion.div>

      {/* Calculator Grid */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-7xl w-full"
      >
        {calculators.map((calc, index) => (
          <motion.div
            key={calc.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 * index }}
            whileHover={{ 
              y: -8, 
              boxShadow: "0 25px 50px -12px rgba(147, 51, 234, 0.4)" 
            }}
            className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:border-purple-300/40 transition-all duration-300 cursor-pointer group"
            onClick={() => handleCalculatorClick(calc.id)}
          >
            {/* Icon Badge */}
            <div className={`w-12 h-12 rounded-xl ${calc.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
              <SafeIcon 
                icon={calc.icon} 
                className="text-2xl text-white"
              />
            </div>

            {/* Content */}
            <h3 className="text-xl font-semibold text-white mb-2 group-hover:text-purple-200 transition-colors duration-300">
              {calc.title}
            </h3>
            <p className="text-sm text-purple-200/70 leading-relaxed">
              {calc.description}
            </p>
          </motion.div>
        ))}
      </motion.div>

      {/* FAQ Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="max-w-4xl w-full mt-24 mb-12"
      >
        <h2 className="text-3xl font-bold text-white text-center mb-10">Häufig gestellte Fragen</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors duration-300"
            >
              <h3 className="text-lg font-semibold text-purple-200 mb-2">
                {faq.q}
              </h3>
              <p className="text-purple-100/70">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default HomePage;